<span
    [matTooltip]="pdfMode ? null : tooltip"
    fxLayout="row"
    [class.text-12-regular]="!isMobile() && !isSpecialChart && !pdfMode"
    [class.text-10-regular]="
        (isMobile() && !isSpecialChart) || (pdfMode && !isSpecialChart)
    "
    [class.h2-24-semi-bold]="!isMobile() && isSpecialChart && !pdfMode"
    [class.text-16-regular]="
        (isMobile() && isSpecialChart) || (pdfMode && isSpecialChart)
    "
    [style.color]="polarityColor"
    class="comparation-percentage-value indicator-color-cyan  {{
        polarityColor
    }}"
    ><i class="{{ icon }}"></i><span>{{ percentage }}</span></span
>
